import React,{ useState } from 'react';
import { Modal, } from 'semantic-ui-react';

const GoToPage = ({ open,pages, onConfirm, onCancel }) => {
  
  const [inputValue, setInputValue] = useState("");

  const handleChange = (e) => {
    setInputValue(e.target.value); // Update state as the user types
  };
const handleConfirm =()=>{
 if(inputValue>0 && inputValue <= pages) {
  onConfirm(inputValue);
  onCancel();
 }
 
}
  return (
   
      <Modal size="tiny" 
      open={open} 
      //onClose={onCancel}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      style={{top:'auto'}} // for positioning of modal at center of view port
         >
       
        <Modal.Content className='border'>

        {/* <input type="text" value={inputValue} onChange={handleChange} /> */}
        <div className="disflex-paginator  ">
            <div className="font-paginator">Go To Page</div>
            <form>
              <input
                style={{
                  maxWidth: "100px",
                  maxHeight: "50px",
                  borderWidth: "2px",
                  borderRadius: "5px",
                  borderColor:'grey'
                }}
                className="inputYp"
                placeholder="number"
                // name="page"
                type="number"
                value={inputValue}
                onChange={handleChange}
                onKeyDown={(event) => {
                  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    event.preventDefault();
                  }
                }} //this Disable arrow key on HTML Number Input in React e.i. number does not increase/decrease on arrow key press
                onWheel={(e) => e.target.blur()}  //this Disable Scrolling on HTML Number Input in React e.i. number does not increase/decrease on scrolling(wheel)
              />
             
            </form>
            {(inputValue <= 0 || inputValue > pages) && <p
                style={{ color: "red" }}
              >
               <b> {`Page number can be 1 to ${pages} only`}</b>
              </p>}
          </div>
        
          <div className= 'flex-center mt-10'>
          <span
                 className="btntask " style={{background:'teal'}}
                   onClick={handleConfirm}     
               >
                    Go
               </span>

          <span
            className="btntask ml-10" 
              onClick={onCancel}

          >
            Cancel
          </span>
          </div>
        </Modal.Content>
      </Modal>
    
  );
}



export default GoToPage;


